export default __webpack_public_path__ + "static/media/walk-run-icon.6a0210e4.svg";